export default __webpack_public_path__ + "static/media/twitter.16ec4858.svg";